module.exports = __webpack_public_path__ + "img/BG831663282.ac4ee9cb.svg";